import { render, staticRenderFns } from "./PastaCompartilhamentoUsuarios.vue?vue&type=template&id=0f493a9c"
import script from "./PastaCompartilhamentoUsuarios.vue?vue&type=script&lang=js"
export * from "./PastaCompartilhamentoUsuarios.vue?vue&type=script&lang=js"
import style0 from "./PastaCompartilhamentoUsuarios.vue?vue&type=style&index=0&id=0f493a9c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports